module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }